import { gql } from "@apollo/client";

export const createLensSpace = gql`
    mutation createLensSpace($organizationId: ID!, $lensSpaceName: String!) {
        createLensSpace(input: { organizationId: $organizationId, lensSpaceName: $lensSpaceName }) {
            lensSpace {
                id
                name
            }
        }
    }
`;
